module.exports = __webpack_public_path__ + "static/media/rishi.d23662fb.jpg";